export default __webpack_public_path__ + "static/media/1828.f3e24a46.png";